import type {
    CompressedMultipleOptionsFilterViewModel,
    PossibleFiltersObject,
    QueryParams,
} from 'tradera/apps/tradera/components/discover/components/filters/types';
import type {
    CategoryFilterViewModel,
    CategoryLinkViewModel,
    ItemCardViewModel,
    PaginationViewModel,
    PriceRangeFilterViewModel,
    SingleOptionFilterViewModel,
    WardrobeProfileViewModel,
} from 'tradera/state/services/types/webapi-discover-generated';

export type InternalSearch = {
    showSearchBar?: boolean;
    placeholder?: string;
};

export type DiscoverState = {
    activeFilters: SingleOptionFilterViewModel[];
    attributeFilters: CompressedMultipleOptionsFilterViewModel[];
    categoryPath: CategoryLinkViewModel[];
    currentCategoryId: number;
    endpoint: string | null;
    error: string | null;
    filterCategories: CategoryFilterViewModel;
    filterPrice: PriceRangeFilterViewModel | null;
    filters: Partial<PossibleFiltersObject>; // converted by normalizeFilters() in src/state/discover/helpers.ts
    wardrobeProfile: WardrobeProfileViewModel | null;
    hasResult: boolean;
    headerText: string | null;
    internalSearch: InternalSearch;
    introText: string | null;
    isCsaSearchQuery: boolean;
    isFetchingGeolocation: boolean;
    isFilterOpen: boolean;
    isSavedSearchEmailEnabled: boolean;
    isShopOwnedByCurrentMember: boolean;
    items: ItemCardViewModel[];
    relatedItems: ItemCardViewModel[];
    itemsOnDisplay: ItemCardViewModel[];
    mainText: string | null;
    pagination: PaginationViewModel | null;
    queryParams: QueryParams | null;
    totalItems: number;
    searchLanguages: string[] | undefined | null;
};

export const initialState: DiscoverState = {
    activeFilters: [],
    attributeFilters: [],
    categoryPath: [],
    currentCategoryId: 0,
    endpoint: null,
    error: null,
    filterCategories: {},
    filterPrice: {},
    filters: {},
    wardrobeProfile: null,
    hasResult: false,
    headerText: null,
    internalSearch: {},
    introText: null,
    isCsaSearchQuery: false,
    isFetchingGeolocation: false,
    isFilterOpen: false,
    isSavedSearchEmailEnabled: false,
    isShopOwnedByCurrentMember: false,
    items: [],
    relatedItems: [],
    itemsOnDisplay: [],
    mainText: null,
    pagination: null,
    queryParams: {},
    totalItems: 0,
    searchLanguages: [],
};
